// @flow

import React, { useState } from 'react'
import type { Node } from 'react'

import ConfigItemModal from './ConfigItemModal'
import NewTable from '../NewTable'
import NewTableBody from '../NewTable/NewTableBody'
import SelectCustom from '../Select/SelectCustom'
import NewTableBodyCell from '../NewTable/NewTableBodyCell'
import NewTableBodyRow from '../NewTable/NewTableBodyRow'
import styles from './ConfigItem.module.scss'

type Props = {
  actionTitle: string,
  addListItemPlaceholder: string,
  addListItemTitle: string,
  createApi: Function,
  listApi: Function,
  listTitle: string,
  modalTitle: string,
  title: string,
}

const RoomType = (props: Props): Node => {
  const { actionTitle, title } = props
  const [isModalOpen, setModalOpen] = useState(false)

  const handleClose = () => setModalOpen(false)
  const handleCreate = () => setModalOpen(true)

  const options = [
    {
      value: title,
      label: actionTitle,
      onClick: handleCreate,
      icon: 'pencil',
    },
  ]

  return (
    <div className={styles.wrap}>
      <NewTable>
        <NewTableBody>
          <NewTableBodyRow onClick={handleCreate}>
            <NewTableBodyCell align='space-between'>
              <div className='table-item table-item__text'>
                <span>{title}</span>
              </div>
              <div
                className='table-extra'
                style={{
                  width: 'auto',
                  display: 'flex',
                  position: 'static',
                  justifyContent: 'center',
                  marginLeft: '10px',
                }}
              >
                <SelectCustom
                  options={options}
                  onChange={option => option.onClick()}
                />
              </div>
            </NewTableBodyCell>
          </NewTableBodyRow>
        </NewTableBody>
      </NewTable>
      {isModalOpen && <ConfigItemModal {...props} onClose={handleClose} />}
    </div>
  )
}

export default RoomType
